export enum PhNotificationStatusEnum{
    OPEN ='OPEN',
    FAILED ='FAILED',
    NOTIFIED ='NOTIFIED',
}